import { ICartEntry } from 'features/cart/types';
import { isRewardCartEntry, mapCartEntriesToLoyaltyCartEntries } from 'features/cart/utils';

import { ILegacyCartEntry } from '@rbi-ctg/menu';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { IAppliedRewards, ICartEntryAdapter } from 'state/loyalty/hooks/types';
import { parseEntry } from 'state/loyalty/hooks/utils/incentive-evaluation';

function isLegacyCartEntry(entry: unknown): entry is ILegacyCartEntry {
  // Checking for _id to differentiate between LegacyCartEntry and CartEntry
  return entry !== null && typeof entry === 'object' && '_id' in entry;
}

function isLegacyCartEntries(entries: unknown[]): entries is ILegacyCartEntry[] {
  return entries.length === 0 || isLegacyCartEntry(entries[0]);
}

// Normalizes raw cart entries (legacy or current shape) into loyalty cart entry
// adapters, dropping applied-reward / reward lines. Shared by both promotion
// sources; the service source remaps the adapters to its productId-based input.
export function parseCartEntries(
  cartEntries: ILegacyCartEntry[] | ICartEntry[] | undefined,
  appliedRewards: IAppliedRewards
): ICartEntryAdapter[] | undefined {
  // Intentionally passing undefined cartEntries when cartEntries is undefined or empty
  // to skip cart requirements check in BE
  if (cartEntries === undefined || cartEntries.length === 0) {
    return undefined;
  }

  if (isLegacyCartEntries(cartEntries)) {
    return cartEntries
      .filter(entry => !appliedRewards[entry.lineId])
      .reduce(parseEntry({ type: LoyaltyPromotionType.SYSTEMWIDE_PROMOTION }), []);
  }

  return mapCartEntriesToLoyaltyCartEntries(
    cartEntries.filter(entry => !isRewardCartEntry(entry)),
    LoyaltyPromotionType.SYSTEMWIDE_PROMOTION
  );
}
